import React, { useState } from 'react';
import { FiPlus } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';

const faqs = [
  {
    question: '¿Qué es Iustia?',
    answer:
      'Iustia es una plataforma que conecta usuarios con abogados especializados. Simplemente registra tu caso y recibe propuestas de profesionales calificados.',
  },
  {
    question: '¿Qué tipos de abogados encuentro?',
    answer:
      'Contamos con abogados en todas las ramas: civil, penal, mercantil, laboral, familiar, y más. Tú eliges con quién contratar.',
  },
  {
    question: '¿Cómo garantizan la calidad?',
    answer:
      'Todos nuestros abogados pasan un proceso de validación de credenciales y son calificados por otros usuarios tras cada servicio.',
  },
  {
    question: '¿Es gratuito buscar abogados?',
    answer:
      'Sí, buscar y comparar perfiles de abogados en Iustia no tiene coste alguno. Solo pagas cuando contratas el servicio.',
  },
  {
    question: '¿Cómo contacto a un abogado?',
    answer:
      'Una vez elijas al abogado, podrás comunicarte directamente vía chat o programar una llamada desde tu panel de usuario.',
  },
];

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const toggleFAQ = idx => setOpenIndex(openIndex === idx ? null : idx);

  return (
    <motion.section
      className="bg-gray-100 py-16 px-4"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: 'easeOut' }}
      viewport={{ once: true, amount: 0.2 }}
    >
      <div className="max-w-3xl mx-auto">
        <motion.h2
          className="text-4xl font-serif font-light text-gray-900 leading-tight mb-12 text-start"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2, ease: 'easeOut' }}
          viewport={{ once: true, amount: 0.2 }}
        >
          ¿Dudas?, nosotros las<span className="italic font-bold"> resolvemos</span>
        </motion.h2>

        <div className="space-y-6">
          {faqs.map((faq, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 + i * 0.1, ease: 'easeOut' }}
              viewport={{ once: true, amount: 0.2 }}
            >
              <button
                onClick={() => toggleFAQ(i)}
                className={`w-full flex justify-between items-start border-b border-gray-600 px-0 py-8 font-semibold font-sans text-gray-800 text-start text-xl ${openIndex === i ? 'bg-gray-50' : ''}`}
              >
                <span className="flex-1 text-left">{faq.question}</span>
                <FiPlus className="text-blue-600 text-lg" />
              </button>
              <AnimatePresence initial={false}>
                {openIndex === i && (
                  <motion.div
                    key="content"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{
                      height: { duration: 0.35, ease: [0.4, 0, 0.2, 1] },
                      opacity: { duration: 0.25 },
                    }}
                    style={{ overflow: 'hidden' }}
                  >
                    <motion.p
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: 10 }}
                      transition={{ duration: 0.3 }}
                      className="mt-4 text-black pl-0 pr-4 py-6 text-start text-lg leading-relaxed text-justify"
                    >
                      {faq.answer}
                    </motion.p>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.section>
  );
};

export default FaqSection;
